// Module
var code = "<div class=\"odf-strong odf-text-mono-color-02\"> <span>{{ data.location.airport }}</span> {{# if (data.terminal) { }} <span>, T{{ data.terminal }}</span> {{# } }} </div>";
// Exports
module.exports = code;